<template>
  <ClientsWidget
    :title="$t('My clients')"
    :subtitle="$t('The companies you work with as a staffing agency')"
    :empty-text="$t('You don\'t have any clients yet')"
    :loading="loading"
    :sections="sections"
  >
    <template #row="{ item }">
      <StaffingAgencyClientRow :client="(item as FragmentType<typeof StaffingAgencyClientFragmentDoc>)" />
    </template>
  </ClientsWidget>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { graphql, type FragmentType } from '@/gql'
import { useTranslation } from '@/composables/translation'
import { ContactStatus, StaffingAgencyClientFragmentDoc } from '@/gql/graphql'
import ClientsWidget from '@/components/Dashboard/Widgets/Clients/ClientsWidget.vue'
import StaffingAgencyClientRow from '@/components/Dashboard/Widgets/Clients/StaffingAgencyClientRow.vue'

const { $t } = useTranslation()
const account = currentAccount.globalId

const { result, loading } = useQuery(
  graphql(`
    query StaffingAgencyClients($id: ID!) {
      recruiter(id: $id) {
        id
        clients {
          id
          status
          ...StaffingAgencyClient
        }
      }
    }
  `),
  () => ({ id: account }),
  {
    clientId: 'publicApi',
    fetchPolicy: 'network-only',
  },
)

const invitedClients = computed(() => [
  ...(result.value?.recruiter?.clients?.filter(
    ({ status }) => status === ContactStatus.Invited,
  ) ?? []),
])

const clients = computed(() =>
  [
    ...(result.value?.recruiter?.clients?.filter(
      ({ status }) =>
        status !== ContactStatus.Invited &&
        status !== ContactStatus.Blocked &&
        status !== ContactStatus.Declined,
    ) ?? []),
  ].reverse(),
)

const sections = computed(() => [
  { label: $t('Pending invitations:'), items: invitedClients.value },
  {
    label: invitedClients.value.length > 0 ? $t('Active clients:') : undefined,
    items: clients.value,
  },
])
</script>
